/* eslint-disable import/prefer-default-export */
export const authProviders = [
	{ label: 'DataScribeID', value: 'local' },
	{ label: 'ORCID', value: 'orcid' },
	{ label: 'GARDIANid', value: 'auth0' },
];
